import { lazy } from "react";
import type { WidgetDefinition } from "../types";

export interface MoonConfig {
  showRiseSet: boolean;
}

const MoonView = lazy(() => import("./MoonView"));

export const moonWidget: WidgetDefinition<MoonConfig> = {
  type: "moon",
  version: 1,
  name: "Moon",
  description: "Tonight’s moon as it really looks, with phase, illumination, moonrise and moonset, and the next full and new moon.",
  icon: "moon",
  category: "weather",
  defaultSize: { w: 3, h: 4 },
  minSize: { w: 2, h: 2 },
  stackHeight: 320,
  defaults: { showRiseSet: true },
  settings: [{ key: "showRiseSet", label: "Show moonrise and moonset", type: "toggle" }],
  provider: "astronomy-engine",
  capabilities: { requiresLocation: true },
  supportsFullscreen: true,
  Component: MoonView,
};
